import { LeftOutlined } from '@ant-design/icons';
import { Card, Form, notification } from 'antd'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import OfferProductForm from './OfferProductForm';
import { useForm } from 'antd/es/form/Form';
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import { OFFER_PRODUCT_BUSINESS_TYPE } from '../../util/Constant';
import { isValidElement, isValidString } from '../../util/ApiHelper';
import { axiosInstance, BASE_API_CONFIG } from '../../util/Api';
import { useGetBreakpoints } from '../../hooks/useGetBreakpoints';
import { fetchStart, fetchSuccess } from '../../appRedux/actions';


const OfferProductDetailsAdmin = () => {
    const [dataId, setDataId] = useState();
    const location = useLocation();
    const dispatch = useDispatch();

    const cloneData = location.state?.cloneData;

    const [selectedProductId, setSelectedProductId] = useState(null);
    const [fileList, setFileList] = useState([
        { label: "primary-image", src: "" },
        { src: "" },
        { src: "" },
        { src: "" },
    ]);
    const [visibleAttachments, setVisibleAttachments] = useState(1);
    const authUser = useSelector(({ auth }) => auth.userData);
    const history = useHistory();
    const [form] = useForm();
    const { id } = useParams();
    const { isMobile } = useGetBreakpoints();
    const productsUnitList = useSelector(
        ({ myProducts }) => myProducts.productsUnitList || []
    );
    const categoryList = useSelector((state) => state.myProducts.categoryList);
    const hsCodeList = useSelector((state) => state.myProducts.hsCodeList);
    const [hsCodeData, setHsCodeData] = useState(null);

    const [filteredHsCodeData, setFilteredHsCodeData] = useState(hsCodeList);
    const [offerProductDetails, setOfferProductDetails] = useState(null);

    let isEditDisabled = false;
    const uniqueProductsUnitList = Array.from(
        new Map(
            (productsUnitList || []).filter(Boolean).map((item) => [item.label, item])
        ).values()
    );
    const validateTextArea = (_, value) => {
        if (value && value.length > 1000) {
            return Promise.reject(
                new Error("Product Requirements cannot exceed 1000 characters")
            );
        }
        return Promise.resolve();
    };

    const handleChangeProductCategory = (value) => {
        form.resetFields(["hsCode"]);
        setFilteredHsCodeData(null);
        setHsCodeData(hsCodeList?.filter((item) => item?.categories?.id === value));
    };

    const handleHSCodeSearch = (value) => {
        const trimmedValue = value.trim();
        const containsNumbers = /^\d+$/.test(trimmedValue.toLowerCase());

        setFilteredHsCodeData(() => {
            const filterFunction = (option) => {
                const codeString = option.code
                    .toString()
                    .replace(/\s+/g, "")
                    .toLowerCase();
                const descriptionString = option.description
                    .replace(/[\n\r"]/g, "")
                    .toLowerCase();

                return containsNumbers
                    ? codeString.includes(trimmedValue.toLowerCase())
                    : descriptionString.includes(trimmedValue.toLowerCase());
            };

            return isValidElement(hsCodeData)
                ? hsCodeData.filter(filterFunction)
                : hsCodeList?.filter(filterFunction);
        });
    };


    const currency = Form.useWatch("currency", form);
    const selectedUOM = Form.useWatch("uom", form);
    const paymentTerms = Form.useWatch("paymentTerms", form);

    const [selectedCurrencies, setSelectedCurrencies] = useState([]);

    useEffect(() => {
        if (id) {
            const fetchOfferDetails = async () => {
                try {
                    dispatch(fetchStart())
                    const response = await axiosInstance.get(
                        `${BASE_API_CONFIG.baseURL}/admin-offer-products/${id}`
                    );
                    setOfferProductDetails(response?.data);
                    setDataId(id);
                } catch (error) {
                    notification.error({
                        message: "Failed",
                        description: "Failed to fetch offer details",
                    });
                } finally {
                    dispatch(fetchSuccess());
                }
            };

            fetchOfferDetails();
        }
    }, [id]);

    useEffect(() => {
        if (cloneData) {
            form.setFieldsValue({
                productName: cloneData.name,
                expiryDate: cloneData.expiryDate
                    ? moment(cloneData.expiryDate)
                    : undefined,
                uom: cloneData.uom,
                price: cloneData.price,
                comments: cloneData.comments,
                currency: cloneData.currency,
                productCategory: cloneData.categoryId,
                hscode: cloneData.hsCodeId,
            });

            if (cloneData.primaryImage) {
                setFileList([
                    { src: cloneData.primaryImage, label: "primary-image" },
                    { src: "" },
                    { src: "" },
                    { src: "" },
                ]);
                setVisibleAttachments(2);
            }

            return;
        }
        if (id && offerProductDetails) {
            form.setFieldsValue({
                productName: offerProductDetails.name,
                expiryDate: moment(offerProductDetails.expiryDate),
                uom: offerProductDetails.uom,
                price: offerProductDetails.price,
                paymentTerms: offerProductDetails.paymentTerms,
                comments: offerProductDetails.comments,
                currency: offerProductDetails.currency,
                productCategory: offerProductDetails.categoryId,
                hscode: offerProductDetails.hsCodeId,
            });

            setSelectedProductId(offerProductDetails.productId);

            let existingImages = [];

            if (offerProductDetails.primaryImage) {
                existingImages = [
                    { src: offerProductDetails.primaryImage, label: "primary-image" },
                ];
            }

            const images = [...existingImages];
            while (images.length < 4) {
                images.push({ src: "" });
            }

            setFileList(images.slice(0, 4));

            const filledImagesCount = existingImages.filter((img) => img?.src).length;
            setVisibleAttachments(Math.min(filledImagesCount + 1, 4));
        }
    }, [cloneData, offerProductDetails, id, form]);


    const onFinish = async (values) => {
        const paymentTerms = values.currency === "INR" ? "FOR" : "FOB";
        const businessTypeIds = values.currency === "INR"
            ? [OFFER_PRODUCT_BUSINESS_TYPE.exporter, OFFER_PRODUCT_BUSINESS_TYPE.manufacturer_exporter]
            : [OFFER_PRODUCT_BUSINESS_TYPE.buyer];

        const primaryImageToSend =
            isValidString(fileList?.[0]?.src) && fileList[0].src
                ? fileList[0].src
                : offerProductDetails?.primaryImage || "";

        const data = {
            productId: selectedProductId,
            categoryId: values?.productCategory,
            businessTypeIds: businessTypeIds,
            hsCodeId: values?.hscode,
            userId: authUser?.id,
            name: values?.productName,
            expiryDate: values?.expiryDate,
            uom: values?.uom,
            price: values?.price,
            currency: values?.currency,
            paymentTerms: paymentTerms,
            comments: values?.comments,
            primaryImage: primaryImageToSend,
            forDestination: values?.forDestination || "",
        };

        try {

            if (dataId && !cloneData) {
                await axiosInstance.post(
                    `${BASE_API_CONFIG.baseURL}/admin-offer-products/${dataId}`,
                    data
                );
                notification.success({
                    message: "Offer Updated",
                    description: "Admin offer product updated successfully "
                })
            } else {
                await axiosInstance.post(
                    `${BASE_API_CONFIG.baseURL}/admin-offer-products`,
                    data
                );

                notification.success({
                    message: "Offer Created",
                    description: "Admin offer product created successfully.",
                });
            }
            history.push("/offer-your-cargo-admin");

        } catch (error) {
            notification.error({
                message: "Failed",
                description: error?.response?.data?.message || "Failed to create offer",
            });
        }
    }
    const onUpload = (data) => {
        setFileList((prevFileList) => {
            const updatedList = [...prevFileList];
            updatedList[data.index].src = data.src;
            if (updatedList.length < 4) {
                updatedList.push({ src: "" });
            }
            updatedList[data.index].originalName = data.originalName;
            return [...updatedList];
        });
    };

    const onRemove = (data) => {
        setFileList((prevFileList) => {
            const updatedList = [...prevFileList];
            updatedList[data.index].src = "";
            return updatedList;
        });
    };

    return (
        <Card
            className="myexim-detail-card"
            title={
                <div className="myexim-table-title gx-text-capitalize">
                    <LeftOutlined
                        className={"back-icon"}
                        size="large"
                        onClick={() => {
                            history.goBack();
                        }}
                    />
                    {dataId ? "Edit" : "Add"} Offer Product
                </div>
            } >

            <OfferProductForm
                form={form}
                onFinish={onFinish}
                onUpload={onUpload}
                onRemove={onRemove}
                uniqueProductsUnitList={uniqueProductsUnitList}
                fileList={fileList}
                visibleAttachments={visibleAttachments}
                validateTextArea={validateTextArea}
                currency={currency}
                selectedUOM={selectedUOM}
                paymentTerms={paymentTerms}
                authUser={authUser}
                isEditDisabled={isEditDisabled}
                isMobile={isMobile}
                history={history}
                setSelectedProductId={setSelectedProductId}
                selectedCurrencies={selectedCurrencies}
                setSelectedCurrencies={setSelectedCurrencies}
                handleChangeProductCategory={handleChangeProductCategory}
                categoryList={categoryList}
                handleHSCodeSearch={handleHSCodeSearch}
                filteredHsCodeData={filteredHsCodeData}
                hsCodeData={hsCodeData}
            />
        </Card>
    )
}

export default OfferProductDetailsAdmin
